<template>
  <div class="btb-success">
    <p class="h1">{{ message }}</p>
    <p class="btb-instruction" v-if="isOnline">{{ instructionOnline }}</p>
    <p class="btb-instruction" v-if="isOnLocation">{{ instructionOnLocation }}</p>
    <p class="btb-notification" v-if="isOnLocation">
      <span>{{ notificationLabel }} </span>
      <span>{{ countdownFormatted }} seconds</span>
    </p>
  </div>
</template>

<script>
import { onlineOrOnLocation } from '@/utils/mixins/onlineOrOnLocation'

export default {
  mixins: [
    onlineOrOnLocation
  ],
  props: {
    onComplete: {
      type: Function
    }
  },
  data () {
    return {
      message: 'Thank you for completing the waiver',
      instructionOnline: `Please arrive 15 minutes before your reservation time.`,
      instructionOnLocation: `After everyone in your reservation has completed their waiver, please notify the front desk.`,
      notificationLabel: `This app will reset in`,
      duration: 10,
      interval: 1000,
      step: 1,
      format: 's',
      countdown: null,
      intervalRef: null
    }
  },
  computed: {
    countdownFormatted () {
      return this.countdown
    }
  },
  mounted () {
    // if (this.isOnLocation) this.start()

    if(process.env.VUE_APP_ONLINE_WAIVER == 0){
      setTimeout(function(){ 
        window.location.href = process.env.VUE_APP_HOME_PAGE;
      }, 5000);
    }
    
  },
  beforeDestroy() {
    this.reset()
  },
  methods: {
    start () {
      // if (!this.countdown || this.countdown < 0) this.countdown = this.duration;
      // this.intervalRef = setInterval(() => {
      //   this.countdown -= this.step
      //   if (this.countdown === 0) {
      //     this.stop()
      //     this.onComplete(this.$router)
      //   }
      // }, this.interval)
      setTimeout(function(){
        window.location.href = process.env.VUE_APP_HOME_PAGE;
      }, 5000);
    },
    stop () {
      clearInterval(this.intervalRef)
    },
    reset () {
      this.stop();
      this.countdown = this.duration;
    }
  }
}
</script>

<style scoped>
.btb-success {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.btb-instruction, .btb-notification {
  margin: 5rem;
  text-align: center;
}
</style>